import {
  Box, DashboardModule, Link,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useCampaign from '@hooks/useCampaign'

import type { CampaignModel } from '@models/types'

import ImageGrid from '../ImageGrid'

const PortalMedia = (props: {campaign: CampaignModel}) => {
  const { campaign } = props

  const campaignPayload = useCampaign({ id: campaign.id }, {
    requestOptions: {
      include_campaign_images: true,
      include_image_sizes: true,
    },
    performHttpRequests: !!campaign.id,
  })

  const {
    callbacks: { bulkSelectImages },
  } = campaignPayload

  const specifiedPortalImageIds = digObject(campaign, 'data.specified_portal_image_ids', [])
  const hasSpecifiedPortalImages = !!specifiedPortalImageIds.length

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      headerRight={(
        <Link
          // @ts-expect-error TS2554
          onClick={() => bulkSelectImages(specifiedPortalImageIds, 'Campaign')}
          textProps={{ fontSize: 'small', textAlign: 'right' }}
        >
          {hasSpecifiedPortalImages ? 'Manage Images' : 'Select Images'}
        </Link>
      )}
      title="Portal Images"
    >
      <Box flexDirection="column">
        {!hasSpecifiedPortalImages && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>No Images Selected</DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              This order item hasn&apos;t had any image preferences specified.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {hasSpecifiedPortalImages && (
          <ImageGrid specifiedImageIds={specifiedPortalImageIds} />
        )}
      </Box>
    </DashboardModule>
  )
}

export default PortalMedia
